import axios from "axios";
import axiosConfig from "../config/axios.config";
import setInterceptor from "../config/set-interceptor";
axios.defaults.withCredentials = true;
const httpService = axios.create({ ...axiosConfig });
setInterceptor(httpService);

export default httpService;
